function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m622.73 389.68v-183.53l-348.8 98.16v277.79c0 30.816-13.508 58.68-35.328 78.75-21.383 19.688-50.75 31.855-83.098 31.855s-61.715-12.168-83.098-31.855c-21.82-20.07-35.301-47.906-35.301-78.75 0-30.816 13.508-58.652 35.301-78.75 21.383-19.688 50.777-31.828 83.098-31.828 29.969 0 57.395 10.445 78.262 27.617v-362.28h0.054687c0-8.75 5.7695-16.789 14.629-19.305l387.65-109.07c2.1055-0.76562 4.375-1.1484 6.7266-1.1484 11.102 0 20.07 8.9961 20.07 20.07v445.26c0 30.816-13.508 58.652-35.301 78.75-21.383 19.688-50.75 31.828-83.098 31.828s-61.742-12.168-83.098-31.828c-21.82-20.07-35.301-47.934-35.301-78.75s13.508-58.652 35.301-78.75c21.383-19.688 50.777-31.828 83.098-31.828 29.941 0 57.395 10.445 78.262 27.617z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default __webpack_public_path__ + "static/media/music_icon.d37ece6fbb9e7f00b62f37f525b75f48.svg";
export { ForwardRef as ReactComponent };